var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.282,177.535c-4.51,3.428-5.41,9.772-2.04,14.199c3.362,4.452,9.73,5.286,14.24,1.868 c4.502-3.428,5.427-9.797,2.057-14.224C247.178,174.933,240.768,174.115,236.282,177.535z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.23,208.477c-3.362-4.444-9.755-5.261-14.257-1.842c-4.51,3.403-5.41,9.78-2.048,14.207 c3.37,4.443,9.738,5.261,14.24,1.858C214.675,219.273,215.592,212.905,212.23,208.477z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.92,237.56c-3.37-4.427-9.755-5.245-14.265-1.842c-4.502,3.428-5.402,9.789-2.04,14.24 c3.362,4.428,9.73,5.246,14.24,1.826C176.357,248.373,177.282,242.004,173.92,237.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.362,264.835c-4.526,3.404-5.427,9.78-2.056,14.224c3.362,4.427,9.746,5.245,14.24,1.817 c4.501-3.402,5.443-9.788,2.056-14.216C132.241,262.233,125.847,261.391,121.362,264.835z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.036,293.918c-4.494,3.428-5.41,9.788-2.048,14.216c3.37,4.452,9.755,5.27,14.24,1.85 c4.51-3.411,5.427-9.779,2.065-14.223C93.931,291.316,87.538,290.515,83.036,293.918z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.224,162.437c4.891-2.024,7.153-7.831,5.023-12.977c-2.123-5.146-7.831-7.69-12.738-5.666 c-4.906,2.04-7.144,7.846-5.022,12.992C211.611,161.932,217.318,164.46,222.224,162.437z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.462,179.683c4.915-2.023,7.178-7.855,5.055-12.976c-2.131-5.154-7.839-7.674-12.745-5.65 c-4.882,2.024-7.146,7.83-5.022,12.976C169.889,179.179,175.58,181.707,180.462,179.683z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.035,178.304c-4.907,2.015-7.145,7.83-5.022,12.993c2.14,5.129,7.83,7.673,12.737,5.625 c4.89-2.016,7.153-7.831,5.03-12.977C141.656,178.8,135.941,176.271,131.035,178.304z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.305,195.542c-4.89,2.024-7.153,7.83-5.03,12.976c2.122,5.172,7.83,7.69,12.736,5.666 c4.907-2.04,7.153-7.847,5.031-12.993C99.92,196.046,94.212,193.502,89.305,195.542z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.559,212.789c-4.906,2.024-7.145,7.846-5.022,12.976c2.139,5.17,7.83,7.69,12.737,5.666 c4.906-2.04,7.169-7.846,5.03-13.001C58.182,213.285,52.474,210.765,47.559,212.789z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.847,230.027c-4.923,2.023-7.17,7.855-5.047,12.984c2.14,5.163,7.831,7.682,12.737,5.667 c4.907-2.024,7.153-7.83,5.03-13.001C16.444,230.531,10.736,227.987,5.847,230.027z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.788,222.041c3.42-4.51,2.602-10.895-1.826-14.24c-4.443-3.387-10.812-2.462-14.24,2.04 c-3.403,4.51-2.585,10.878,1.842,14.256C271.008,227.467,277.376,226.542,280.788,222.041z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.639,248.15c-3.42,4.51-2.602,10.878,1.85,14.24c4.419,3.387,10.787,2.47,14.198-2.04 c3.42-4.486,2.603-10.895-1.825-14.257C245.418,242.731,239.05,243.648,235.639,248.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.605,298.643c3.403-4.486,2.585-10.854-1.842-14.24c-4.444-3.362-10.812-2.437-14.224,2.065 c-3.42,4.485-2.602,10.879,1.842,14.257C212.808,304.094,219.177,303.17,222.605,298.643z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.439,324.761c-3.42,4.526-2.602,10.895,1.842,14.256c4.427,3.362,10.796,2.446,14.207-2.04 c3.444-4.51,2.618-10.878-1.825-14.256C187.235,319.35,180.867,320.275,177.439,324.761z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.339,363.095c-3.42,4.486-2.577,10.854,1.842,14.24c4.427,3.386,10.795,2.445,14.223-2.065 c3.428-4.485,2.602-10.854-1.842-14.24C158.136,357.66,151.768,358.585,148.339,363.095z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.863,231.068c-5.146-2.122-10.953,0.14-12.977,5.056c-2.048,4.881,0.496,10.573,5.65,12.712 c5.146,2.123,10.953-0.123,12.977-5.03C316.536,238.899,314.009,233.215,308.863,231.068z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.616,272.806c-5.146-2.123-10.952,0.124-12.976,5.047c-2.041,4.89,0.503,10.573,5.649,12.72 c5.146,2.123,10.952-0.14,12.976-5.022C299.29,280.645,296.762,274.929,291.616,272.806z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.378,314.543c-5.146-2.123-10.961,0.124-13.002,5.047c-2.023,4.89,0.521,10.597,5.65,12.72 c5.163,2.122,10.978-0.124,12.992-5.031C282.043,322.374,279.523,316.667,274.378,314.543z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.131,356.28c-5.146-2.122-10.953,0.124-13.001,5.031c-2.016,4.906,0.529,10.614,5.675,12.736 c5.146,2.123,10.952-0.14,12.976-5.022C264.804,364.111,262.277,358.403,257.131,356.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.884,398.018c-5.146-2.123-10.969,0.124-12.992,5.03c-2.024,4.907,0.495,10.598,5.65,12.713 c5.146,2.148,10.968-0.116,12.992-5.006C247.558,405.849,245.038,400.141,239.884,398.018z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.621,439.756c-5.122-2.123-10.952,0.124-12.976,5.03c-2.023,4.907,0.504,10.59,5.65,12.72 c5.146,2.14,10.978-0.124,13.001-5.014C230.311,447.587,227.791,441.879,222.621,439.756z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M419.258,53.686c-25.458-0.008-48.684,10.325-65.41,26.993l-0.008-0.008l-18.875,18.362l23.929,23.912 l18.585-18.064l0.124-0.124c10.688-10.672,25.341-17.23,41.655-17.238c16.321,0.008,30.942,6.566,41.655,17.254 c10.688,10.705,17.246,25.325,17.255,41.655v301.918H512V146.429C511.992,95.192,470.486,53.694,419.258,53.686z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "351.559,129.975 327.786,106.202 325.466,103.881 240.867,103.799 222.043,122.623 335.642,236.222  354.442,217.39 354.383,132.791  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroom);
export default __webpack_public_path__ + "static/media/bathroom.21fe537d04eb7f444dc7d1e1aa84a5d1.svg";
export { ForwardRef as ReactComponent };